import React, { useContext } from 'react';
import useSetState from '../../utils/useSetState';
import signupForCurriculum from './utils/signupForCurriculum';
import { GetCurriculum } from '../../components';
import { FeedbackContext } from '../../containers/context/FeedbackContext/FeedbackContext';
import { LangContext } from '../../containers/context/LangContext';

const GetCurriculumContainer = () => {
  const [state, setState] = useSetState({
    email: '',
    accept_terms: false,
    accept_marketing: false,
    success: false
  });

  const { setFeedbackState } = useContext(FeedbackContext);
  const { translations, lang } = useContext(LangContext);

  return (
    <GetCurriculum
      state={state}
      setState={setState}
      onSubmitHandler={signupForCurriculum.bind(null, {
        state,
        setState,
        setFeedbackState,
        translations,
        lang
      })}
    />
  );
};

export default GetCurriculumContainer;
